import { useState, type FormEvent } from 'react';
import { api } from '../../api';
import { tiposDe } from '../../componentes/formatos';
import { NOME_PRIORIDADE } from '../agenda/comum';
import { EscolherLocal, type Escolha } from './EscolherLocal';
import { NOME_ORIGEM } from './comum';

/** Registrar chamado. Só a descrição é obrigatória: quem atende o telefone não pode travar esperando cadastro. */
export function FormChamado({ aoSalvar, aoCancelar }: { aoSalvar: (r: { id: string }) => void; aoCancelar: () => void }) {
  const [f, setF] = useState({ origem: 'telefone', prioridade: 'media', descricao: '', solicitante_nome: '', solicitante_telefone: '' });
  const [onde, setOnde] = useState<Escolha>({ cliente_id: null, cliente: null, local_id: null });
  const [erro, setErro] = useState<string | null>(null);
  const [salvando, setSalvando] = useState(false);
  const set = (k: keyof typeof f) => (e: { target: { value: string } }) => setF((x) => ({ ...x, [k]: e.target.value }));

  async function enviar(e: FormEvent) {
    e.preventDefault(); setErro(null); setSalvando(true);
    try {
      const r = await api<{ id: string }>('/chamados', { metodo: 'POST', corpo: {
        origem: f.origem, prioridade: f.prioridade, descricao: f.descricao.trim(),
        solicitante_nome: f.solicitante_nome.trim() || null, solicitante_telefone: f.solicitante_telefone.trim() || null,
        cliente_id: onde.cliente_id, local_id: onde.local_id,
      } });
      aoSalvar(r);
    } catch (err) { setErro(err instanceof Error ? err.message : 'Não foi possível registrar.'); }
    finally { setSalvando(false); }
  }

  return (
    <form className="form" onSubmit={enviar}>
      <div className="linha-2">
        <label>Chegou por
          <select value={f.origem} onChange={set('origem')}>
            {tiposDe(NOME_ORIGEM).filter(([v]) => v !== 'portal').map(([v, r]) => <option key={v} value={v}>{r}</option>)}
          </select>
        </label>
        <label>Prioridade
          <select value={f.prioridade} onChange={set('prioridade')}>{tiposDe(NOME_PRIORIDADE).map(([v, r]) => <option key={v} value={v}>{r}</option>)}</select>
        </label>
      </div>
      <div className="linha-2">
        <label>Telefone de quem pediu
          <input type="tel" inputMode="tel" value={f.solicitante_telefone} onChange={set('solicitante_telefone')} placeholder="(19) 99999-9999" />
        </label>
        <label>Nome
          <input value={f.solicitante_nome} onChange={set('solicitante_nome')} maxLength={120} placeholder="Ex.: Sr. João, porteiro da noite" />
        </label>
      </div>
      <p className="nota">Telefone de contato cadastrado já identifica o cliente e o parque. Se não souber de onde é, deixe em branco: fica para a triagem.</p>
      <EscolherLocal valor={onde} aoMudar={setOnde} />
      <label>O que está acontecendo
        <textarea required minLength={5} maxLength={4000} rows={4} value={f.descricao} onChange={set('descricao')} autoFocus
          placeholder='Ex.: "Portão de veículos da entrada não fecha desde as 7h; ronda está segurando manualmente."' />
      </label>
      {erro && <p className="alerta" role="alert">{erro}</p>}
      <div className="acoes-form">
        <button type="button" className="btn-fantasma" onClick={aoCancelar}>Cancelar</button>
        <button className="btn" disabled={salvando || f.descricao.trim().length < 5}>{salvando ? 'Salvando…' : 'Registrar chamado'}</button>
      </div>
    </form>
  );
}
